import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const manageUsers = createAsyncThunk("manageUsers", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.get(
      `${API_KEY}/api/user/user-list/${data.id ? data.id : " "}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          ...(data.filters.status && { status: data.filters.status }),
          ...(data.filters.startDate &&
            data.filters.endDate && {
              startDate: data.filters.startDate,
              endDate: data.filters.endDate,
            }),
          ...(data.filters.role && { role: data.filters.role }),
        },
        "Content-Type": "application/json",
      }
    );

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  manageUsersData: null,
  isError: false,
  errorMessage: "",
};

const manageUsersSlice = createSlice({
  name: "manageUsers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(manageUsers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(manageUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.manageUsersData = action.payload;
    });
    builder.addCase(manageUsers.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default manageUsersSlice.reducer;
